const SoFormStepSuccess = {
  nameForData: 'SO_FORM_STEP_SUCCESS',
  hideHeader: true,
  hideFooter: true,
};

export default SoFormStepSuccess;
